module.exports = __webpack_public_path__ + "img/wine-placeholder-yellow.be71de96.png";